import request from '../request';

export function getIncomes(params) {
  return request({
    url: "/products-incomes",
    method: "get",
    params
  })
}

export function getPageIncomes(id) {
  return request({
    url: `/products-incomes?page=${id}`,
    method: "get",
  })
}

export function getIncomesID(id) {
  return request({
    url: `/products-incomes/${id}`,
    method: "get",
  })
}

export function postIncomes(data) {
  return request({
    url: "/products-incomes",
    method: "post",
    data
  })
}

export function putIncomes(data) {
  return request({
    url: `/products-incomes/${data.id}`,
    method: "put",
    data
  })
}

export function deleteIncomes(id) {
  return request({
    url: `/products-incomes/${id}`,
    method: "delete",
  })
}

export function getStockProducts() {
  return request({
    url: '/product-stock',
    method:'get',
  })
}
